export interface AuthSignInPayload {
  readonly email: string;
  readonly password: string;
}
